import React from 'react'
import NotificationToast, {
  NotificationToastData,
} from './NotificationToast.component'
import './NotificationToastContainer.css'

interface NotificationToastContainerProps {
  toasts: NotificationToastData[]
  onClose: (id: string) => void
  onAction?: (id: string) => void
}

const NotificationToastContainer: React.FC<NotificationToastContainerProps> = ({
  toasts,
  onClose,
  onAction,
}) => {
  if (toasts.length === 0) {
    return null
  }

  return (
    <div className="notification-toast-container">
      {toasts.map((toast) => (
        <NotificationToast
          key={toast.id}
          notification={toast}
          onClose={onClose}
          onAction={onAction}
        />
      ))}
    </div>
  )
}

export default NotificationToastContainer
